import { render, staticRenderFns } from "./DashBoardRightChart.vue?vue&type=template&id=1696f84e&scoped=true&"
import script from "./DashBoardRightChart.vue?vue&type=script&lang=js&"
export * from "./DashBoardRightChart.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardRightChart.vue?vue&type=style&index=0&id=1696f84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1696f84e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
